import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from './i18n';
import {isRequired, validationMixin} from '@aofl/form-validate';

/**
 * @summary SaveReportForm
 * @extends {validationMixin(i18nMixin(AoflElement))}
 */
@customElement('save-report-form')
class SaveReportForm extends validationMixin(i18nMixin(AoflElement)) {
  constructor() {
    super();

    this.translations = translations;

    this.validators = {
      title: {
        isRequired
      }
    };
  }

  /**
   * @readonly
   */
  static is = 'save-report-form';

  @property({type: Boolean})
  saving = false;

  updateTitle(e) {
    const value = e.target.value;
    this.title = value;
  }
  validateTitle(e) {
    this.form.title.validate();
  }
  updateDescription(e) {
    const value = e.target.value;
    this.description = value;
  }

  cancel() {
    this.dispatchEvent(new CustomEvent('save-report-cancel'));
  }

  async submit(e) {
    e.preventDefault();
    this.form.validate();
    await this.form.validateComplete;

    if (this.form.valid) {
      const formData = new FormData(e.target);
      this.title = formData.get('title');
      this.description = formData.get('description');

      this.dispatchEvent(new CustomEvent('save-report', {
        bubbles: true,
        composed: true
      }));
    }
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default SaveReportForm;
